/* eslint-disable no-undef */
export default {
	name: "dispense-order-item-for-order-table",
	props: ["orderId", "orderTypeId"],
	emits: ["dispenseUpdate"],
	data() {
		return {
			products: [],
			orderItems: [],
			customerHeadings: [
				{
					text: "Customer #",
					field: "companyId"
				},
				{
					text: "Customer Code",
					field: "customerCode"
				},
				{
					text: "Name",
					field: "registeredCompanyName"
				},
				{
					text: "ERP Customer Code",
					field: "erpCompanyCode"
				},
				{
					text: "VAT Number",
					field: "taxVatNumber"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			filter:{
				searchQuery: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			orderTotal: 0,
			orderTotalAsString: null,
			newAssignedCustomers: [],
			newUnassignedCustomers: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			useFourDecimalPlaces: false
		};
	},
	methods: {
		getOrderItems() {
			orderService.getOrderItemsForOrder(this.orderId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.orderItems = successResponse.data.result;
						this.orderItems = dataTableHelper.castObjectValues(this.orderItems);
						for(var i = 0; i < this.orderItems.length; i++){
							this.orderItems[i].priceAsString = currencyHelper.numberToCurrency(this.orderItems[i].unitPrice);
							this.orderItems[i].totalAsString = currencyHelper.numberToCurrency(this.orderItems[i].totalAmount);
							this.orderItems[i].totalAmountDispensedAsString = currencyHelper.numberToCurrency(this.orderItems[i].totalAmountDispensed);
							this.orderItems[i].discountedAmountAsString = "";
							this.orderItems[i].priceAfterDiscount = 0;
							this.orderItems[i].priceAfterDiscountAsString = "";
							this.orderItems[i].totalAfterDiscount = 0;
							this.orderItems[i].totalAfterDiscountAsString = "";
							this.orderItems[i].totalAmountDispensedAsString = "";
							this.orderItems[i].discountedAmountDispensedAsString = "";
							this.orderItems[i].totalDiscountedAmountDispensed = 0;
							this.orderItems[i].totalDiscountedAmountDispensedAsString = "";
							this.orderItems[i].totalDispensedAfterDiscount = 0;
							this.orderItems[i].totalDispensedAfterDiscountAsString = "";
							if(this.useFourDecimalPlaces){
								this.orderItems[i].priceAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderItems[i].unitPrice);
								this.orderItems[i].totalAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderItems[i].totalAmount);
								this.orderItems[i].totalAmountDispensedAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderItems[i].totalAmountDispensed);
							}
							if(this.orderItems[i].quantityDispensed !== null && this.orderItems[i].quantityDispensed > 0) {
								this.orderItems[i].totalAmountDispensed = this.orderItems[i].quantityDispensed * this.orderItems[i].unitPrice;
								if(this.useFourDecimalPlaces){
									this.orderItems[i].totalAmountDispensedAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderItems[i].totalAmountDispensed);
								}
								else{
									this.orderItems[i].totalAmountDispensedAsString = currencyHelper.numberToCurrency(this.orderItems[i].totalAmountDispensed);
								}
							}
							if(this.orderItems[i].discountedAmount !== null && this.orderItems[i].discountedAmount > 0){
								this.orderItems[i].discountedAmountAsString = currencyHelper.numberToCurrency(this.orderItems[i].discountedAmount);
								this.orderItems[i].priceAfterDiscount = this.orderItems[i].unitPrice - this.orderItems[i].discountedAmount;
								this.orderItems[i].priceAfterDiscountAsString = currencyHelper.numberToCurrency(this.orderItems[i].priceAfterDiscount);
								this.orderItems[i].totalAfterDiscount = this.orderItems[i].quantity * this.orderItems[i].priceAfterDiscount;

								this.orderItems[i].totalDiscountedAmountDispensed = this.orderItems[i].quantityDispensed * this.orderItems[i].discountedAmount;
								this.orderItems[i].discountedAmountDispensed = this.orderItems[i].discountedAmount;
								this.orderItems[i].totalDiscountedAmountDispensedAsString = currencyHelper.numberToCurrency(this.orderItems[i].totalDiscountedAmountDispensed);

								this.orderItems[i].totalDispensedAfterDiscount = this.orderItems[i].quantityDispensed * this.orderItems[i].priceAfterDiscount;
								this.orderItems[i].totalDispensedAfterDiscountAsString = currencyHelper.numberToCurrency(this.orderItems[i].totalDispensedAfterDiscount);
								if(this.useFourDecimalPlaces){
									this.orderItems[i].discountedAmountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderItems[i].discountedAmount);
									this.orderItems[i].priceAfterDiscountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderItems[i].priceAfterDiscount);
									this.orderItems[i].totalDiscountedAmountDispensedAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderItems[i].totalDiscountedAmountDispensed);
									this.orderItems[i].totalDispensedAfterDiscountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderItems[i].totalDispensedAfterDiscount);
								}
							}
						}
						console.log("orderItems", this.orderItems);
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onQuantityInput(orderItem){
			// if(product.quantity === null || product.quantity === ""){
			// 	product.quantity = 1;
			// }
			// else if(product.quantity <= 0){
			// 	product.quantity = 1;
			// }
			
			// product.total = product.quantity * product.basePrice;
			// product.totalAsString = currencyHelper.numberToCurrency(product.total);
			// if(product.discountAmount !== null && product.discountAmount > 0){
			// 	product.discountedAmountTotal = currencyHelper.roundToTwoDecimalPlaces(product.quantity * product.discountAmount);
			// 	product.totalAfterDiscount = currencyHelper.roundToTwoDecimalPlaces(product.quantity * product.priceAfterDiscount);
			// 	product.totalAfterDiscountAsString = currencyHelper.numberToCurrency(product.totalAfterDiscount);
			// }
			// this.calculateGrandTotalForOrder();
			// this.onProductSelect();
			var markAsSelected = false;
			if(orderItem.quantityDispensed !== null && orderItem.quantityDispensed > 0) {
				if(orderItem.quantityDispensed <= orderItem.quantity) {
					orderItem.totalAmountDispensed = orderItem.quantityDispensed * orderItem.unitPrice;
					orderItem.totalAmountDispensedAsString = currencyHelper.numberToCurrency(orderItem.totalAmountDispensed);
					orderItem.totalDispensedAfterDiscount = orderItem.quantityDispensed * orderItem.priceAfterDiscount;
					orderItem.totalDispensedAfterDiscountAsString = currencyHelper.numberToCurrency(orderItem.totalDispensedAfterDiscount);
					markAsSelected = true;
				}
				else{
					orderItem.quantityDispensed = orderItem.quantity;
					orderItem.totalAmountDispensed = orderItem.quantityDispensed * orderItem.unitPrice;
					orderItem.totalAmountDispensedAsString = currencyHelper.numberToCurrency(orderItem.totalAmountDispensed);
					orderItem.totalDispensedAfterDiscount = orderItem.quantityDispensed * orderItem.priceAfterDiscount;
					orderItem.totalDispensedAfterDiscountAsString = currencyHelper.numberToCurrency(orderItem.totalDispensedAfterDiscount);
					markAsSelected = true;
				}
			}
			if(orderItem.discountedAmount !== null && orderItem.discountedAmount > 0){
				orderItem.discountedAmountAsString = currencyHelper.numberToCurrency(orderItem.discountedAmount);
				orderItem.priceAfterDiscount = orderItem.unitPrice - orderItem.discountedAmount;
				orderItem.priceAfterDiscountAsString = currencyHelper.numberToCurrency(orderItem.priceAfterDiscount);

				if(this.useFourDecimalPlaces){
					orderItem.totalAfterDiscount = currencyHelper.roundToFourDecimalPlaces(orderItem.quantity * orderItem.priceAfterDiscount);

					orderItem.totalDiscountedAmountDispensed = currencyHelper.roundToFourDecimalPlaces(orderItem.quantityDispensed * orderItem.discountedAmount);
				}
				else{
					orderItem.totalAfterDiscount = currencyHelper.roundToTwoDecimalPlaces(orderItem.quantity * orderItem.priceAfterDiscount);
					orderItem.totalDiscountedAmountDispensed = currencyHelper.roundToTwoDecimalPlaces(orderItem.quantityDispensed * orderItem.discountedAmount);
				}

				//orderItem.discountedAmountDispensed = orderItem.discountedAmount;
				orderItem.totalDiscountedAmountDispensedAsString = currencyHelper.numberToCurrency(orderItem.totalDiscountedAmountDispensed);
			}

			if(this.useFourDecimalPlaces){
				orderItem.totalAmountDispensedAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(orderItem.totalAmountDispensed);
				orderItem.totalDispensedAfterDiscountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(orderItem.totalDispensedAfterDiscount);


				orderItem.discountedAmountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(orderItem.discountedAmount);
				orderItem.priceAfterDiscountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(orderItem.priceAfterDiscount);
				
				//orderItem.discountedAmountDispensed = orderItem.discountedAmount;
				orderItem.totalDiscountedAmountDispensedAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(orderItem.totalDiscountedAmountDispensed);
			}
			
			if(markAsSelected){
				this.onDispenseUpdate();
			}
			else{
				this.$emit("dispenseUpdate", []);
			}
		},
		// calculateGrandTotalForOrder(){
		// 	this.orderTotal = 0;
		// 	for(let i = 0; i < this.products.length; i++){
		// 		if(this.products[i].selected){
		// 			if(this.products[i].discountAmount !== null && this.products[i].discountAmount > 0){
		// 				this.orderTotal += this.products[i].totalAfterDiscount;
		// 			}
		// 			else {
		// 				this.orderTotal += this.products[i].total;
		// 			}
		// 			this.orderTotal = currencyHelper.roundToTwoDecimalPlaces(this.orderTotal);
		// 		}
		// 	}
		// 	this.orderTotalAsString = currencyHelper.numberToCurrency(this.orderTotal);
		// },
		onDispenseUpdate(){
			this.$emit("dispenseUpdate", this.orderItems);
		},
		// onProductSelect(){
		// 	this.orderTotal = 0;
		// 	let selectedProducts = [];
		// 	for(let i = 0; i < this.products.length; i++){
		// 		if(this.products[i].selected){
		// 			if(this.products[i].discountAmount !== null && this.products[i].discountAmount > 0){
		// 				this.products[i].totalAfterDiscount = this.products[i].quantity * this.products[i].priceAfterDiscount;
		// 				this.orderTotal += this.products[i].totalAfterDiscount;
		// 			}
		// 			else{
		// 				this.orderTotal += this.products[i].total;
		// 			}
		// 			this.orderTotal = currencyHelper.roundToTwoDecimalPlaces(this.orderTotal);
		// 			this.products[i].total = currencyHelper.roundToTwoDecimalPlaces(this.products[i].quantity * this.products[i].basePrice);
		// 			selectedProducts.push(this.products[i]);
		// 		}
		// 	}
		// 	this.orderTotalAsString = currencyHelper.numberToCurrency(this.orderTotal);
		// 	this.$emit("productSelected", selectedProducts);
		// }
	},
	mounted: function () {
        
	},
	watch:{
		// shippingAddressId:{
		// 	handler: function () {
		// 		if(this.shippingAddressId !== null && this.companyId !== null){
		// 			this.getProducts();
		// 		}
		// 	},
		// 	immediate: true,
		// 	deep: true
		// }
		orderId:{
			handler: function () {
				if(this.orderId !== null && this.orderId > 0){
					this.getOrderItems();
				}
			},
			immediate: true,
			deep: true
		},
		orderTypeId: {
			handler: function () {
				if(this.orderTypeId !== null && this.orderTypeId > 0){
					if(this.orderTypeId === orderHelper.orderType.exTank){
						this.useFourDecimalPlaces = true;
					}
				}
			},
			immediate: true,
			deep: true
		}
	}
};
